import { UpdateDeliveryAddressState } from './updateDeliveryAddress.types'

const initialState: UpdateDeliveryAddressState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
